import React from 'react';
import {connect} from 'react-redux';
import { Formik, getIn } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Collapse, Card} from 'react-bootstrap';
import Stats from '../Stats';
import NumberFormat from '../NumberFormat';

const schema = yup.object().shape({
    ror: yup.number().max(10,'Projected rate of return should be 10% or less.').required('Please enter rate of return')
  });

class Step7 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
  handleSubmit(values,props) {
    // console.log('---here are values',values);
    // let retirementAccounts = this.props.getForm().scenario.retirementAccounts;
    // if(Array.isArray(retirementAccounts)){
    //     retirementAccounts = retirementAccounts.map(ra => {  
    //        ra.rateOfReturn = values.ror;
    //     return ra; 
    //     });
    // }
    values = {
        // retirementAccounts:retirementAccounts,
        rateOfReturnBeforeRetirement: values.ror,
        rateOfReturnAfterRetirement: values.ror
    };
    this.props.upliftState(values,'scenario');
    this.props.nextStep();
    return;
  }
   
  render() {
     
    return(

                 <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props}
                    validationSchema={schema}
                    onSubmit={this.handleSubmit}
                >
                {({
                        handleSubmit,
                        handleChange,
                        setFieldValue,
                        setFieldTouched,
                        values,
                        errors,
                        touched,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit} >
                            <Card className="stepChild">
                                <Card.Header>
                                    <Row >
                                    <span style={{'position':'absolute','paddingLeft':'15px'}}><strong>7.</strong></span>
                                    <Col md={"10"} sm={"12"} style={{'paddingLeft':'35px'}}>
                                            {this.props.getStepHeader(7) } 
                                        </Col>
                                        <Col md={"2"} sm={"12"}>
                                            <Stats type="edit" step={7} {...this.props} />
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Collapse in={this.props.isActive}>
                                    <Card.Body>
                                        <Form.Row>
                                            <Form.Group as={Col} md="4" controlId="validationFormikror">
                                            <Form.Label className="required">Rate of Return (%)</Form.Label>
                                            <NumberFormat
                                                value={values.ror} 
                                                suffix={'%'} 
                                                onValueChange={e => {  setFieldValue( 'ror', e.floatValue);
                                                            setFieldTouched( 'ror',true);  }}
                                                error={ getIn(errors,'ror') }
                                                />
                                            </Form.Group>
                                        </Form.Row>
                                        <Form.Row>
                                        <Form.Group as={Col} md="12" style={{"padding":"0px","margin":"0px"}} controlId="step7Continue">
                                            <Col md={"12"} sm={"12"}>
                                                <Stats type='continue' step={7} {...this.props} />
                                            </Col>
                                        </Form.Group>
                                    </Form.Row>
                                </Card.Body>
                            </Collapse>
                        </Card>
                        </Form>
                    )}
                    </Formik>
    );
   }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
    let {client,scenario} = form;
        if(!client.isMarried || client.isMarried === 'false'){
            client.spouse = {};
            scenario.spouse = {employment:{}};
        }
        let ror = scenario.rateOfReturnBeforeRetirement || scenario.rateOfReturnAfterRetirement;
        return {
            form,
            ror,
            isMarried:client.isMarried,
            scenario,
            ...ownProps
        }
  }
 export default connect(
    mapStateToProps,
    null
    )(Step7)